import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { ImageListItem } from '@mui/material';
import { t } from 'i18next';
import { SimpleTable } from '~/views/molecules/simple-table/simple-table';
export const RelatedFiles = ({ files }) => {
    const config = useMemo(() => {
        return {
            headerColumns: [
                {
                    label: t('DIALOG_FILE_INFO_ID'),
                    columnWidth: 4,
                },
                {
                    label: t('DIALOG_FILE_INFO_RELATED_FILES_TITLE'),
                    columnWidth: 8,
                },
            ],
            rowColumns: [
                {
                    fieldKey: 'id',
                    columnWidth: 4,
                },
                {
                    fieldKey: 'description',
                    columnWidth: 8,
                },
            ],
        };
    }, []);
    return (_jsx(Fragment, { children: _jsx(ImageListItem, { sx: { paddingTop: 0 }, className: 'table-view', children: _jsx(SimpleTable, { config: config, data: files }) }) }));
};
